import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import Box from "grommet/components/Box";
import AppSettings from "../../../utils/appSettings";
import Status from "grommet/components/icons/Status";
import Meter from "grommet/components/Meter";
import Button from "grommet/components/Button";
import Value from "grommet/components/Value";
import Add from "grommet/components/icons/base/Add";
import Heading from "grommet/components/Heading";
import Label from "grommet/components/Label";
import Circles from "../../../ressources/circles.svg";
import { DateTime } from "luxon";
import { withSnackbar } from "../../snackbar";
import { selectNoMoreMapRequestToFetch, selectMapRequestRefreshLength } from "../../../store/actions/mapRequest";

const DateTimeLabel = ({ date }) => {
  let lux = DateTime.fromISO(date);
  return (
    <Label size="small" className="no-margin">
      {lux.setLocale("fr").toLocaleString(DateTime.DATETIME_SHORT)}
    </Label>
  );
};

const MapRequestStatus = ({ status, progress }) => {
  switch (status) {
    case "QUEUED":
      return <Status value="disabled" />;
    case "DONE":
      return <Status value="ok" />;
    case "PROCESSING":
      return (
        <Box>
          <Value value={progress} units="%" size="xsmall" align="start" />
          <Meter size="xsmall" value={progress} onActive={() => {}} />
        </Box>
      );
    case "ERROR":
      return <Status value="critical" />;
    default:
      throw new Error("Unknown mapRequest Status, ", status);
  }
};

class MapRequestList extends React.Component {
  render() {
    let {
      mapRequests,
      push,
      onStartWizard,
      fetchMore,
      noMoreMapRequestToFetch,
      selectNoMoreMapRequestToFetch,
      snackbar,
      selectMapRequestRefreshLength
    } = this.props;
    if (mapRequests.length === 0) {
      return (
        <Box margin="large" align="center" id="mapRequestList">
          <img src={Circles} alt="Pas de cartes" style={{ objectFit: "cover", maxHeight: "400px" }}/>
          <Box align="center">
            <Label style={{ textAlign: "center" }}>Votre organisation n'a pas encore lancé de recherche cartographique</Label>
            <Button
              label="Créer votre première recherche"
              primary
              icon={<Add style={{ stroke: "#FFF" }} />}
              onClick={() => onStartWizard()}
            />
          </Box>
        </Box>
      );
    }
    return (
      <Box style={{ maxWidth: "800px", width: "80%" }} margin="large" pad={{ between: "medium" }} id="mapRequestList">
        <Box align="center">
          <Heading tag="h2">Vos recherches cartographiques:</Heading>
        </Box>
        {mapRequests.map(mapRequest => (
          <Box
            key={mapRequest.id}
            direction="row"
            justify="between"
            align="center"
            className="mapRequestCard"
            colorIndex={AppSettings.cardColor}
            pad="medium"
            onClick={() => {
              push(`/app/map/${mapRequest.id}`);
            }}
          >
            <MapRequestStatus status={mapRequest.status} progress={mapRequest.progress} />
            {mapRequest.name} - {mapRequest.case.name}
            <DateTimeLabel date={mapRequest.createdAt} />
          </Box>
        ))}
        <Box align="center" pad="large">
          {fetchMore && !noMoreMapRequestToFetch ? (
            <Button
              label="Charger plus de résultats"
              onClick={() =>
                fetchMore({
                  variables: {
                    after: mapRequests[mapRequests.length - 1].id //Get the last id
                  },
                  updateQuery: (prev, { fetchMoreResult }) => {
                    console.log(fetchMoreResult);
                    if (fetchMoreResult.myOrganisationMapRequests.length === 0) {
                      selectNoMoreMapRequestToFetch(true);
                      snackbar.showMessage("Vous avez atteint la fin de la liste de résultat", "warning");
                      return prev;
                    }
                    selectNoMoreMapRequestToFetch(false);
                    const newArr = [...prev.myOrganisationMapRequests, ...fetchMoreResult.myOrganisationMapRequests];
                    selectMapRequestRefreshLength(newArr.length);
                    return Object.assign({}, prev, {
                      myOrganisationMapRequests: newArr
                    });
                  }
                })
              }
            />
          ) : (
            undefined
          )}
        </Box>
      </Box>
    );
  }
}

const mapStateToProps = state => {
  return {
    noMoreMapRequestToFetch: state.mapRequest.noMoreMapRequestToFetch
  };
};
const mapDispatchToProps = dispatch => {
  return {
    push: url => {
      dispatch(push(url));
    },
    selectNoMoreMapRequestToFetch: end => {
      dispatch(selectNoMoreMapRequestToFetch(end));
    },
    selectMapRequestRefreshLength: len => {
      dispatch(selectMapRequestRefreshLength(len));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar()(MapRequestList));
